
function isTestEnv(hostname) {
    const testEnvs = ['localhost', 'test-', 'dev-'];
    return testEnvs.some(env => hostname.indexOf(env) === 0);
}

function isLocalEnv(hostname) {
    const testEnvs = ['localhost', '127.', '0.'];
    return testEnvs.some(env => hostname.indexOf(env) === 0);
}

function defaultBaseUrl() {
    const host = window.location.hostname

    if (isLocalEnv(host)) {
        return 'http://localhost:8010/proxy/'
    }

    const envPrefix = isTestEnv(host) ? 'dev-' : '';
    return `https://${envPrefix}api-factsheets-smap.landcareresearch.co.nz/`;
}

function params(gisLayer, soilMapUnitCode) {
    return new URLSearchParams([
        ['gislayer', gisLayer],
        ['soilmapunitcode', soilMapUnitCode]
    ]);
}

function fetchJson(url) {
    return fetch(url).then(r => {
        if (r.ok) {
            return r.json();
        }
        throw new Error(`not ok ${r.status} ${r.statusText}`)
    });
}

export class SMUFactsheetsAPI {
    constructor(baseURL) {
        this.baseURL = baseURL || defaultBaseUrl();
    }

    siblings(gisLayer, soilMapUnitCode) {
        const url = new URL('factsheets/siblings', this.baseURL);
        return fetchJson(`${url}?${params(gisLayer, soilMapUnitCode)}`)
    }

    polygons(gisLayer, soilMapUnitCode) {
        const url = new URL('factsheets/polygons', this.baseURL);
        return fetchJson(`${url}?${params(gisLayer, soilMapUnitCode)}`);
    }

    envelopes(gisLayer, soilMapUnitCode) {
        const url = new URL('factsheets/envelope', this.baseURL);
        return fetchJson(`${url}?${params(gisLayer, soilMapUnitCode)}`)
            .then(r => {
                return r.map(s => {
                    return {
                        ...s,
                        shape: s.envelope
                    }
                })
            })
    }

    surveyinfo(gisLayer, soilMapUnitCode) {
        const url = new URL('factsheets/surveyinfo', this.baseURL);
        return fetchJson(`${url}?${params(gisLayer, soilMapUnitCode)}`);
    }
}

export class MaoriFactsheetAPI {
    constructor(baseUrl) {
        this.baseUrl = baseUrl || defaultBaseUrl();
    }

    spatial(params) {
        const url = new URL('factsheets/maori/spatial', this.baseUrl);

        const query = new URLSearchParams(params);

        return fetchJson(`${url}?${query}`);
    }

    images(imageType, params) {
        const url = new URL(`factsheets/maori/images/${imageType}`, this.baseUrl);

        const query = new URLSearchParams(params);

        return fetchJson(`${url}?${query}`);
    }

    landform(params) {
        const url = new URL('factsheets/maori/landform', this.baseUrl);
        const { gisLayer, soilMapUnitCode } = params;
        return fetchJson(`${url}?${new URLSearchParams({ gisLayer, soilMapUnitCode })}`);
    }

    kumara(objectId, siblingRankOrder) {
        const url = new URL('factsheets/maori/kumara', this.baseUrl);
        const params = new URLSearchParams({objectId, siblingRankOrder});
        return fetchJson(`${url}?${params}`);
    }
}